/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../atoms/effects/skeletons/utils/SkeletonSettings";

export const ProductRowSkeleton = (props) => (
    <ContentLoader
        width={"100%"}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{borderTop: SkeletonSettings.BORDER}}
        {...props}>

        {/* Thumbnail image */}
        <rect x="0" y={`calc(50% - 40px)`} width="80" height="80"/>

        {/* Product details */}
        <rect x="90" y={`calc(50% - 40px)`} rx="3" ry="3" width="30%" height="10"/>
        <rect x="90" y={`calc(50% - 16px)`} rx="3" ry="3" width="28%" height="10"/>
        <rect x="90" y={`calc(50% + 4px)`} rx="3" ry="3" width="26%" height="10"/>
        <rect x="90" y={`calc(50% + 30px)`} rx="3" ry="3" width="20%" height="10"/>

        {/* Packaging info */}
        <rect x="48%" y={`calc(50% - 5px)`} rx="3" ry="3" width="8%" height="10"/>

        {/* Weight price */}
        <rect x="57%" y={`calc(50% - 5px)`} rx="3" ry="3" width="8%" height="10"/>

        {/* Unit price */}
        <rect x="66%" y={`calc(50% - 5px)`} rx="3" ry="3" width="8%" height="10"/>

        {/* Quantity selector */}
        <rect x={`calc(83% - 1% - 5px)`} y={`calc(50% - 1.5px)`} width="1%" height="3"/>
        <rect x="83%" y={`calc(50% - 20px)`} width="40" height="40"/>
        <rect x={`calc(83% + 45px)`} y={`calc(50% - 1.5px)`} width="1%" height="3"/>

        {/* Add to cart button */}
        <circle cx={`calc(100% - 28px)`} cy="50%" r="28"/>

    </ContentLoader>
)
